<template>
	<div class="grupo" @click="abrirGrupo">
		<Imagens :imagens="imagem" :galeria="false" class="grupo__imagem" :abrirImagem="false"/>
        <div class="grupo__nome">{{grupo.nome}}</div>
	</div>
</template>

<script>
import Imagens from '../shared/Imagens.vue'

export default {
	props: {
		grupo: Object,
	},
	components: {
		Imagens,
	},
	data: function () {
		return {}
	},
	computed: {
		imagem() {
			return this.grupo.url_img
				? [{ url_img: this.grupo.url_img }]
				: [{ url_img: require(`@/assets/produto.png`) }]
		},
	},
	methods: {
        abrirGrupo(){
			this.$router.push(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							grupo: this.grupo.nome,
							pagina: 1,
						}
					),
				},
				() => {}
			)
		},
    },
}
</script>

<style scoped>
.grupo {
	width: 250px;
	height: 250px;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 2rem;
    position: relative;
    display: flex;
    align-content: flex-end;
    align-items: flex-end;
    justify-content: center;
}

.grupo__imagem{
    position: absolute;
}


.grupo__nome{
    background-color: var(--v-primary-base);
    color: white;
    font-weight: 900;
	font-size: 16px;
	text-transform: uppercase;
    text-align: center;
    position: absolute;
    margin-bottom: 0;
    margin-top: auto;
    width: 100%;
    padding: 1rem;
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
    
}

</style>

